import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { CompareContentItem, CompareSettingChange } from "../../types";
import { ChangeStatusLabel } from "../ChangeStatusLabel/ChangeStatusLabel";
import { CompareRow } from "../CompareRow/CompareRow";
import {
  Column,
  Dot,
  Header,
  HeaderAside,
  HeaderSubtitle,
  HeaderTextBlock,
  HeaderTitle,
  List,
  SettingRow,
  SettingsSection,
  SettingsTitle,
} from "./styles";

export interface CompareColumnProps {
  variant: "live" | "changes";
  testId: string;
  headerTitle: ReactNode;
  headerSubtitle?: ReactNode;
  headerAside?: ReactNode;
  items: CompareContentItem[];
  settingChanges?: CompareSettingChange[];
  withDivider?: boolean;
}

export const CompareColumn = ({
  variant,
  testId,
  headerTitle,
  headerSubtitle,
  headerAside,
  items,
  settingChanges,
  withDivider,
}: CompareColumnProps) => (
  <Column data-testid={testId} $withDivider={withDivider}>
    <Header>
      <Dot $variant={variant} />
      <HeaderTextBlock>
        <HeaderTitle $variant={variant}>{headerTitle}</HeaderTitle>
        {headerSubtitle && <HeaderSubtitle>{headerSubtitle}</HeaderSubtitle>}
      </HeaderTextBlock>
      {headerAside && <HeaderAside>{headerAside}</HeaderAside>}
    </Header>

    <List>
      {items.map((item: CompareContentItem) => (
        <CompareRow key={item.id} item={item} sideKey={variant} />
      ))}
    </List>

    {settingChanges && settingChanges.length > 0 && (
      <SettingsSection data-testid={`${testId}-settings`}>
        <SettingsTitle>
          <FormattedMessage
            id="compare_changes.settings.title"
            defaultMessage="Settings"
          />
        </SettingsTitle>
        {settingChanges.map((setting) => (
          <SettingRow
            key={setting.id}
            data-testid={`compare-setting-${setting.id}`}
          >
            <span>{setting.label}</span>
            <ChangeStatusLabel
              changeType={setting.changeType}
              idSuffix={`setting-${setting.id}`}
            />
          </SettingRow>
        ))}
      </SettingsSection>
    )}
  </Column>
);
